import { Link } from 'react-router-dom';

import { useSite } from '../../context/SiteProvider.jsx';
import { useReveal } from '../common/Reveal.jsx';

/**
 * On the homepage a card reveals the matching product feature in place (the
 * original behaviour). Everywhere else it links to the product page.
 */
export function CatalogCard({ product, to, onSelect }) {
  const { t, pick, money } = useSite();
  const { ref, isVisible } = useReveal();

  const className = `catalog-card reveal${isVisible ? ' visible' : ''}`;

  // Sheet-style covers (several items photographed together) need the whole
  // frame rather than the usual inset.
  const imageClass = `catalog-card-image${product.coverIsTall ? ' is-tall-cover' : ''}`;

  const body = (
    <>
      <div className={imageClass}>
        <img src={product.cardImage} alt={pick(product.coverAlt) || pick(product.name)} loading="lazy" />
        {!product.inStock ? <span className="catalog-card-stock">{t('outOfStock')}</span> : null}
      </div>
      <div className="catalog-card-body">
        {product.badge ? <span className="catalog-card-tag">{pick(product.badge.label)}</span> : null}
        <h3>{pick(product.name)}</h3>
        {product.sizes?.length ? (
          <p className="catalog-card-sizes">
            {product.sizes.map((size, index) => <span key={index}>{pick(size)}</span>)}
          </p>
        ) : null}
        <p className="catalog-card-price">
          {product.hasMultiplePrices ? <span>{t('fromPrice')}</span> : null}
          {product.priceFrom === null ? '' : ` ${money(product.priceFrom)}`}
        </p>
        <span className="catalog-card-link">
          <span>{t('viewProduct')}</span>
          <span>↗</span>
        </span>
      </div>
    </>
  );

  if (onSelect) {
    return (
      <a
        ref={ref}
        className={className}
        href={`#${product.domId}`}
        onClick={(event) => {
          event.preventDefault();
          onSelect(product);
        }}
      >
        {body}
      </a>
    );
  }

  return (
    <Link ref={ref} className={className} to={to ?? `/product/${product.slug}`}>
      {body}
    </Link>
  );
}
